import React from 'react';
import PropTypes from 'prop-types';
import { FormText } from 'reactstrap';
import { ErrorMessage } from 'formik';

const Component = ({ name, ...props }) => {
  return (
    <ErrorMessage
      {...props}
      name={name}
      render={(errorMessage) => (
        <FormText color='danger' {...props}>
          {errorMessage}
        </FormText>
      )}
    />
  );
};
Component.propType = {
  name: PropTypes.string.isRequired,
};

export default Component;
